import { useMediaQuery } from 'react-responsive';
import AddIcon from '@mui/icons-material/Add';
import { Button } from '@mui/material';
import DataTableWrapper from 'src/components/DataTableWrapper';
import formatPhoneNumber from 'src/util/formatPhoneNumber';
import getStatusChip from 'src/util/getStatusChip';
import { pick } from 'lodash';
import { useContext } from 'react';
import BusinessContext from 'src/store/business-context';
import { Field, useFormikContext } from 'formik';
import { Typography, Card, CardContent } from '@mui/material';
import MuiCheckbox from 'src/components/input/MuiCheckbox';

const ContactSection = () => {
  const isDesktop = useMediaQuery({ query: '(min-width: 768px)' });
  const { setSelectedContact, setUpdatingContact, openModal, contacts, setContactAgreement } =
    useContext(BusinessContext);
  const { setFieldValue } = useFormikContext();

  const getAccountType = (params) => {
    switch (params.row.partyType) {
      case 'A':
        return 'Agent';
      case 'B':
        return 'Business';
      case 'C':
        return 'Contact';
      case 'O':
        return 'Owner';
    }
  };

  const getFullAddress = ({ row }) => {
    return `${row.addrStreet || ''} ${row.addrCity?.toUpperCase() || ''} ${
      row.addrState?.toUpperCase() || ''
    } ${row.addrZip || ''}`;
  };

  const args = {
    title: 'Contacts',
    rows: contacts,
    columns: [
      {
        field: 'addDel',
        headerName: 'Status',
        flex: 1,
        minWidth: 100,
        renderCell: getStatusChip,
      },
      {
        field: 'partyType',
        headerName: 'Type',
        flex: 2,
        valueGetter: getAccountType,
        minWidth: 100,
      },
      {
        field: 'partyName',
        headerName: 'Name',
        flex: 3,
        minWidth: 300,
      },
      {
        field: 'fullAddress',
        headerName: 'Address',
        flex: 4,
        valueGetter: getFullAddress,
        minWidth: 325,
      },
      {
        field: 'emailAddr',
        headerName: 'Email',
        flex: 3,
        minWidth: 250,
      },
      {
        field: 'phone',
        headerName: 'Phone',
        flex: 3,
        minWidth: 125,
        valueGetter: (params) => formatPhoneNumber(params.row.phone),
      },
    ],
    rowClick: ({ row }) => {
      let existingValues = pick(row, [
        'partyName',
        'partyType',
        'emailAddr',
        'phone',
        'cellPhone',
        'addrStreet',
        'addrCity',
        'addrState',
        'addrZip',
      ]);
      existingValues.phone = formatPhoneNumber(existingValues.phone);
      existingValues.cellPhone = formatPhoneNumber(existingValues.cellPhone);

      setSelectedContact(existingValues);
      setUpdatingContact(row);

      openModal();
    },
  };

  return (
    <>
      <DataTableWrapper {...args}>
        <Button
          id="add-contact"
          variant="outlined"
          onClick={() => {
            openModal();
          }}
        >
          <AddIcon sx={{ mr: '0.125rem', fontSize: '1.4rem' }} />
          {isDesktop && <span>Add Contact</span>}
        </Button>
      </DataTableWrapper>

      <Card sx={{ marginY: '1rem' }}>
        <CardContent>
          <br />
          <Typography>
            {`I understand by adding a contact to this account, I am giving the individual
    authorization to contact, be contacted, and speak on behalf of the business to the
    Utah County Assessor's office.`}
          </Typography>
          <Field
            component={MuiCheckbox}
            name="contactAgreement"
            label={'I agree'}
            sx={{ float: 'right' }}
            onChange={(e) => {
              setContactAgreement(e.target.checked);
              setFieldValue('contactAgreement', e.target.checked);
            }}
          />
        </CardContent>
      </Card>
    </>
  );
};

export default ContactSection;
